module.exports = new __parcel__URL__("Ani_Taturashvili.a844d4c2.jpg").toString();